import * as RadixPopover from "@radix-ui/react-popover";
import { useState } from "react";
import PopoverContext from "./PopoverContext";

export type PopoverProps = {
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  className?: string;
  isOpen?: boolean;
  setIsOpen?: (isOpen: boolean) => void;
  children: React.ReactNode;
  content: React.ReactNode;
};

export default function Popover({
  side,
  align,
  className,
  children,
  content,
}: PopoverProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <PopoverContext.Provider value={{ isOpen, setIsOpen }}>
      <RadixPopover.Root open={isOpen} onOpenChange={setIsOpen}>
        <RadixPopover.Trigger asChild>{children}</RadixPopover.Trigger>
        <RadixPopover.Portal>
          <RadixPopover.Content
            side={side}
            align={align}
            className={className}
            style={{ zIndex: 9999 }}
          >
            {content}
          </RadixPopover.Content>
        </RadixPopover.Portal>
      </RadixPopover.Root>
    </PopoverContext.Provider>
  );
}
